import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http/http-client.service';

@Injectable({
  providedIn: 'root',
})
export class UploadService {

  constructor(private http: HttpService) { }

  uploadFile(file: File, url: string, successHandler: Function, errorHandler: Function): void {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.doPost(url, formData, successHandler, errorHandler);
  }


  uploadFileBase64(url: string, formData: any, successHandler: Function, errorHandler: Function): void {
    return this.http.doPost(url, formData, successHandler, errorHandler);
  }

  buscarDadosModeloPreenchido(url: string, successHandler: Function, errorHandler?: Function) {
    return this.http.doGet(url, '', successHandler, errorHandler);
  }
}
